import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { StarInput, StarsRow } from '../../../components/NewReviewModal';
import { getEcologyRating } from '../../../selectors/newReview';
import { setEcologyRating } from '../../../actions/newReview';
import { REVIEWS_VALUES } from '../../../constants/reviews';
import { isActive, isHovered } from './utils';

export function EcologyRatingContainer() {
  const name = 'ecologyRating';
  const dispatch = useDispatch();
  const current = useSelector(getEcologyRating);
  const [hover, setHover] = React.useState<number | null>(null);

  const setCurrentRating = (value: number) => () => {
    dispatch(setEcologyRating(value));
  };

  const onMouseEnter = (value: number) => () => {
    setHover(value);
  };

  const onMouseLeave = () => {
    setHover(null);
  };

  return (
    <StarsRow title="Экология">
      {REVIEWS_VALUES.map(value => {
        return (
          <StarInput
            isActive={isActive({ value, current })}
            isHover={isHovered({ value, hover })}
            name={name}
            value={value}
            key={`${name}_${value}`}
            onClick={setCurrentRating(value)}
            onMouseEnter={onMouseEnter(value)}
            onMouseLeave={onMouseLeave}
          />
        );
      })}
    </StarsRow>
  );
}
